import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 18 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 13\" id=\"check\">\n  <defs>\n    <style>\n      #check .check_line {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    </style>\n  </defs>\n  <title>checkmark</title>\n  <polyline class=\"check_line\" points=\"1 7 6 12 17 1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol